// CNPJ analysis texts (merged under the "cnpj" key: t('cnpj.home.title')).
export default {
  nav: 'Análise de CNPJ',
  common: {
    disabledTitle: 'Análise de CNPJ não disponível',
    disabledText: 'A Análise de CNPJ não está ligada para esta empresa. Fale com o suporte para ativar.',
    forbiddenTitle: 'Sem permissão',
    forbiddenText: 'O seu papel não permite usar a Análise de CNPJ.',
    loadError: 'Não foi possível carregar a Análise de CNPJ.',
    heuristic: 'Nota heurística de apoio à decisão; não é parecer.',
  },
  home: {
    title: 'Análise de CNPJ',
    subtitle: 'Rede societária de uma empresa: sócios, outras empresas deles e sinais de risco.',
    noKeyTitle: 'Falta a chave de API',
    noKeyText: 'As pesquisas usam a conta da própria empresa no serviço de consulta. Cadastre a chave para começar.',
    noKeyAsk: 'As pesquisas usam a conta da própria empresa no serviço de consulta. Peça a quem administra a empresa para cadastrar a chave.',
    openSettings: 'Cadastrar a chave',
  },
  status: {
    queued: 'Na fila',
    running: 'Pesquisando',
    completed: 'Concluída',
    incomplete: 'Incompleta',
    failed: 'Com erro',
    paused: 'Pausada',
  },
  control: {
    pause: 'Pausar',
    resume: 'Continuar',
    prioritize: 'Passar na frente',
    paused: 'Pesquisa pausada.',
    pausing: 'Pausando: a consulta atual termina e a pesquisa para.',
    resumed: 'A pesquisa voltou para a fila e vai seguir de onde parou.',
    prioritized: 'A pesquisa passou para a frente da fila.',
    stopping: 'Pausando: termina a consulta atual e para.',
    yielding: 'Dando a vez a uma pesquisa que passou na frente; continua logo depois, de onde parou.',
    pausedText: 'Pausada com {calls} consultas feitas. Ao continuar, segue de onde parou, sem consultar de novo o que já foi consultado.',
    retryAt: 'Erro temporário. Nova tentativa automática às {time}, de onde parou.',
    failedHint: 'Ao continuar, a pesquisa segue de onde parou, sem consultar de novo o que já foi consultado.',
    ahead: 'Na frente',
  },
  verdict: {
    low: 'Risco baixo',
    moderate: 'Risco moderado: verificar',
    elevated: 'Risco elevado',
    high: 'Risco alto',
  },
  searches: {
    filterAll: 'Todas',
    filterRunning: 'Em andamento',
    scope: 'De quem',
    scopeAll: 'De todos',
    scopeMine: 'Minhas',
    filter: 'Filtrar por nome ou CNPJ',
    balance: 'Saldo de créditos',
    balanceAt: 'lido em {date}',
    balanceUnknown: 'lido ao fim de cada pesquisa',
    allSearches: 'Pesquisas concluídas',
    mySearches: 'Minhas pesquisas concluídas',
    creditsSpent: 'Créditos gastos',
    average: 'média de {n} por pesquisa',
    apiCalls: 'Consultas feitas',
    cacheHits: '{n} respondidas pelo cache',
    emptyTitle: 'Nenhuma pesquisa ainda',
    emptyText: 'Pesquise um CNPJ para ver os sócios, as outras empresas deles e os sinais de risco.',
    noMatch: 'Nenhuma pesquisa com esse filtro',
    truncated: 'Mostrando as {n} pesquisas mais recentes.',
    queuedNext: 'É a próxima',
    queuedBehind: '{n} pesquisa na frente | {n} pesquisas na frente',
    runningProgress: 'Nível {level} · {calls} consultas',
    size: '{companies} empresas · {people} pessoas',
    columns: {
      company: 'Empresa',
      status: 'Situação',
      score: 'Nota',
      date: 'Pedida em',
      requestedBy: 'Pedida por',
      depth: 'Profundidade',
      size: 'Rede',
      credits: 'Créditos',
      calls: 'Consultas',
      duration: 'Duração',
    },
  },
  newSearch: {
    title: 'Nova pesquisa',
    cnpjs: 'CNPJ',
    cnpjsHint: 'Um ou vários, separados por linha, vírgula ou espaço. Cada CNPJ vira uma pesquisa na fila.',
    cnpjsPlaceholder: '00.000.000/0000-00',
    valid: 'Nenhum CNPJ válido | 1 CNPJ válido | {n} CNPJs válidos',
    invalid: 'Inválidos (ficam de fora): {list}',
    depth: 'Profundidade',
    depthHint: '1 = os sócios e as outras empresas deles; cada nível a mais vai um passo além (mais consultas).',
    maxCalls: 'Máximo de consultas',
    maxCallsHint: 'Ao chegar nele, a pesquisa para e mostra o que juntou. Pode levar até {minutes} min no limite do seu plano.',
    maxCallsRange: 'Entre 1 e {max}.',
    extended: 'Coleta estendida',
    extendedHint: 'Busca endereço, telefone e e-mail das empresas suspeitas de reabertura (fênix). Pode gastar créditos.',
    forceRefresh: 'Consultar tudo de novo',
    forceRefreshHint: 'Ignora as respostas guardadas dos últimos dias. Pode gastar créditos e leva mais tempo.',
    submit: 'Pesquisar',
    submitMany: 'Pesquisar {n} CNPJs',
    queued: '1 pesquisa na fila | {n} pesquisas na fila',
    ignored: 'Ficaram de fora (inválidos): {list}',
  },
  result: {
    notFound: 'Pesquisa não encontrada',
    requested: 'Pedida por {who} em {when}',
    params: 'Profundidade {depth} · até {calls} consultas',
    extended: 'Coleta estendida',
    fresh: 'Sem o cache',
    progress: 'Pesquisando o nível {level}: {calls} consultas feitas e {cache} respondidas pelo cache',
    current: 'Agora: {name}',
    progressHint: 'Pode sair desta tela: a pesquisa continua e fica no histórico.',
    failed: 'A pesquisa não terminou.',
    incomplete: 'A pesquisa chegou ao máximo de {calls} consultas: a rede pode estar incompleta e alguns sinais podem não aparecer. Refaça com um máximo maior (as consultas já feitas vêm do cache).',
    score: 'Nota',
    composition: 'Base {base} + {positives} − {risks}',
    network: 'Rede',
    companies: '1 empresa | {n} empresas',
    people: '1 pessoa | {n} pessoas',
    networkIncomplete: 'incompleta (chegou ao máximo de consultas)',
    networkDepth: 'completa até a profundidade {depth}',
    cost: 'Custo',
    credits: '{n} créditos',
    costDetail: '{calls} consultas · {cache} do cache · {duration}',
    rulesVersion: 'Regras versão {version}, idades contadas a partir de {date}.',
    levels: 'Mostrar',
    upTo: 'Até 1 salto | Até {n} saltos',
    allLevels: 'Tudo',
    hidden: '1 item oculto | {n} itens ocultos',
    highlighting: 'Destacando {rule}.',
    clearHighlight: 'Limpar',
    fit: 'Centralizar',
    graphLabel: 'Rede com {companies} empresas e {people} pessoas',
    legend: {
      target: 'Empresa pesquisada',
      company: 'Empresa',
      inactive: 'Não ativa',
      person: 'Pessoa',
      minor: 'Menor de idade',
      pending: 'Não consultada',
    },
    risks: 'Riscos',
    risksEmpty: 'Nenhum sinal de risco encontrado.',
    positives: 'Pontos positivos',
    positivesEmpty: 'Nenhum ponto positivo encontrado.',
    context: 'Contexto (não conta na nota)',
    contextEmpty: 'Nada a destacar.',
    distance: 'a 1 salto da empresa | a {n} saltos da empresa',
    checklist: 'Conferir em outras fontes',
    costTitle: 'Custo da pesquisa',
    creditsBefore: 'Saldo antes',
    creditsAfter: 'Saldo depois',
    endpointCost: '{calls} consultas · {cache} do cache',
    duration: 'Duração',
    redo: 'Refazer',
    redoTitle: 'Refazer a pesquisa',
    redoCache: 'Usar o cache',
    redoFresh: 'Consultar tudo de novo',
    redoCacheHint: 'Uma pesquisa nova com os mesmos parâmetros; o que foi consultado nos últimos dias vem do cache, sem custo.',
    redoFreshHint: 'Consulta tudo de novo: dados mais recentes, mas pode gastar créditos e leva mais tempo.',
    reanalyze: 'Analisar com as regras v{version}',
    reanalyzed: 'Análise refeita com as regras v{version}, sem novas consultas.',
    export: 'Exportar',
  },
  node: {
    root: 'Raiz {root}',
    unknown: 'Não informada',
    status: 'Situação',
    since: 'desde {date}',
    founded: 'Abertura',
    equity: 'Capital social',
    size: 'Porte e natureza',
    activity: 'Atividade principal',
    sideActivities: 'Secundárias',
    sideCount: '1 atividade | {n} atividades',
    address: 'Endereço',
    contacts: 'Contatos',
    notConsulted: 'Empresa não consultada (fora da profundidade ou do máximo de consultas): só o que veio pelos sócios.',
    personNotConsulted: 'Pessoa não consultada: as outras empresas dela não entraram na rede.',
    age: 'Faixa etária',
    country: 'País',
    personType: { NATURAL: 'Pessoa física', LEGAL: 'Pessoa jurídica', FOREIGN: 'Estrangeira' },
    partners: 'Nenhum sócio | 1 sócio | {n} sócios',
    companies: 'Nenhuma empresa | 1 empresa | {n} empresas',
    sameEntity: 'É a própria empresa (sócia pessoa jurídica)',
  },
  apiKey: {
    title: 'Chave da CNPJá',
    intro:
      'A Análise de CNPJ consulta os sócios e as empresas deles na CNPJá, com a conta da própria empresa: o consumo de créditos e o limite de consultas por minuto são os do seu plano. A chave fica cifrada e nunca é mostrada de novo.',
    missing: 'Sem a chave, não é possível pesquisar.',
    configured: 'Chave cadastrada',
    endsWith: 'termina em {hint}',
    updatedAt: 'atualizada em {date}',
    replace: 'Trocar a chave',
    remove: 'Remover',
    label: 'Chave da API da CNPJá',
    hint: 'Em cnpja.com › Conta › Chaves de API.',
    save: 'Salvar a chave',
    saved: 'Chave da CNPJá salva',
    removed: 'Chave da CNPJá removida',
    test: 'Testar conexão',
    testOkTitle: 'Conexão OK',
    testOk: 'A CNPJá aceitou a chave. Saldo: {credits} créditos.',
    testFailTitle: 'Falhou',
    testErrors: {
      api_key_missing: 'Nenhuma chave cadastrada para testar.',
      api_key_rejected: 'A CNPJá recusou a chave. Confira se foi copiada inteira e se está ativa.',
      rate_limited: 'A CNPJá recusou por excesso de consultas. Tente de novo em um minuto.',
      unavailable: 'Não foi possível falar com a CNPJá agora. Tente de novo em alguns minutos.',
    },
  },
  permissions: {
    group: 'Análise de CNPJ',
    groupHint: 'Pesquisa da rede societária de empresas (sócios e outras empresas deles) com a conta da empresa no serviço de consulta.',
    ownerLocked: 'O dono tem todas as permissões da Análise de CNPJ.',
    changes: 'Análise de CNPJ: {items}',
    changesNone: 'sem permissões',
    cnpj_pesquisar: 'Pesquisar CNPJ',
    cnpj_pesquisar_hint: 'Faz pesquisas (consomem os créditos da conta da empresa) e vê as próprias.',
    cnpj_historico: 'Ver todas as pesquisas de CNPJ',
    cnpj_historico_hint: 'Vê as pesquisas de todas as pessoas da empresa. Contêm dados pessoais de sócios de terceiros.',
    cnpj_configurar: 'Configurar a Análise de CNPJ',
    cnpj_configurar_hint: 'Cadastra a chave de API da empresa. Inclui pesquisar e ver todas as pesquisas.',
  },
}
